// extracted by mini-css-extract-plugin
export default {"v-standardBorder":"var(--standardBorder)","v-white":"var(--white)","root":"popover__root__Ihgsv"};